'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'alarm-clock';
var width = 512;
var height = 512;
var aliases = [9200];
var unicode = 'f34e';
var svgPathData = 'M366.3 34.1c-2.5 2-5.8 2.7-8.8 1.5-5.3-2.2-7-9-2.7-12.7 16.6-14.2 38.3-22.9 61.9-22.9 52.6 0 95.2 42.6 95.2 95.2 0 17.5-4.7 33.9-12.9 47.9-2.9 5-9.9 4.5-13-.3-1.7-2.7-1.7-6.2-.1-8.9 6.4-11.4 10.1-24.6 10.1-38.7 0-43.8-35.5-79.2-79.2-79.2-19.2 0-36.7 6.8-50.4 18.1zM25.9 142.9c-3.1 4.9-10.1 5.3-13 .3-8.2-14.1-12.9-30.5-12.9-47.9 0-52.6 42.6-95.2 95.2-95.2 23.6 0 45.2 8.6 61.9 22.9 4.4 3.7 2.7 10.6-2.7 12.7-3 1.2-6.3 .6-8.8-1.5-13.7-11.3-31.3-18.1-50.4-18.1-43.8 0-79.2 35.5-79.2 79.2 0 14 3.7 27.2 10.1 38.7 1.6 2.8 1.6 6.2-.1 8.9zM464 288a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM408.6 451.9C368.6 489.2 315 512 256 512s-112.6-22.8-152.6-60.1L45.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l57.7-57.7C54.8 400.6 32 347 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 59-22.8 112.6-60.1 152.6l57.7 57.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-57.7-57.7zM264 168l0 132.2 77 61.6c3.4 2.8 4 7.8 1.2 11.2s-7.8 4-11.2 1.2l-80-64c-1.9-1.5-3-3.8-3-6.2l0-136c0-4.4 3.6-8 8-8s8 3.6 8 8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAlarmClock = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;